<template>
  <!-- Page Title Start -->
  <div class="row">
    <div class="col-12">
      <div class="page-title-box d-flex align-items-center justify-content-between">
        <h4 class="ms-2 mb-0 font-size-18 ion-text-primary">{{ $t(`menu.${title}`) }}</h4>
      </div>
    </div>
  </div>
  <!-- Page Title End -->
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    }
  }
}
</script>
